var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCopy = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17.5 2.7v1.6h2.3A2.7 2.7 0 0 1 22.6 7v14.2a2.7 2.7 0 0 1-2.8 2.7h-12A2.7 2.7 0 0 1 5 21.2v-3.1H2.7v-.2A2.7 2.7 0 0 1 0 15.4V2.7A2.7 2.7 0 0 1 2.7 0h12a2.7 2.7 0 0 1 2.8 2.7m-2.1 1.6V2.7l-.2-.4-.4-.2h-12l-.5.2-.2.4v12.7l.2.4.4.2h2.4V7a2.7 2.7 0 0 1 2.7-2.7Zm5 16.9V7l-.2-.6-.4-.2h-12l-.4.2-.2.6v14.2l.2.4.4.2h12l.4-.2z",
    clipRule: "evenodd"
  })));
};
export default SvgCopy;